var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuDashboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .MenuDashboard_a {\n                fill: #ff0d0d;\n                opacity: 0;\n            }\n\n            .MenuDashboard_b {\n            }\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-22 -363)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "MenuDashboard_a",
    width: 24,
    height: 24,
    transform: "translate(22 363)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-480.88 -423.77)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "MenuDashboard_b",
    d: "M523.309,786.77H506.451a3.619,3.619,0,0,0-3.571,3.571V807.2a3.619,3.619,0,0,0,3.571,3.571h16.858a3.619,3.619,0,0,0,3.571-3.571V790.341a3.619,3.619,0,0,0-3.571-3.571Zm1.264,19.846a1.852,1.852,0,0,1-1.846,1.846H507.034a1.852,1.852,0,0,1-1.846-1.846V790.924a1.851,1.851,0,0,1,1.846-1.846h15.692a1.852,1.852,0,0,1,1.846,1.846Zm0,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "MenuDashboard_b",
    d: "M648.485,950.631a1.637,1.637,0,0,0-1.6,1.659v6.832a.6.6,0,0,0,.583.6h2.043a.6.6,0,0,0,.583-.6V952.29a1.637,1.637,0,0,0-1.6-1.659Zm7-7.541a1.638,1.638,0,0,0-1.6,1.659v14.373a.6.6,0,0,0,.583.6h2.043a.6.6,0,0,0,.584-.6V944.749a1.638,1.638,0,0,0-1.6-1.659Zm7,4.9a1.638,1.638,0,0,0-1.6,1.659v9.471a.6.6,0,0,0,.584.6h2.043a.6.6,0,0,0,.584-.6v-9.471a1.638,1.638,0,0,0-1.605-1.659Zm0,0",
    transform: "translate(-140.608 -152.638)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDashboard);
export default __webpack_public_path__ + "static/media/MenuDashboard.f049b2222e95372101ab85e9d8663a79.svg";
export { ForwardRef as ReactComponent };